export class ProcessingStatus {

  key: string;

  dictionaryKey: string;
  dictionaryKeyForward: string;
  dictionaryKeyBackward: string;

  constructor(status: ProcessingStatus) {
    this.key = status.key;
    this.dictionaryKey = status.dictionaryKey;
    this.dictionaryKeyForward = status.dictionaryKeyForward;
    this.dictionaryKeyBackward = status.dictionaryKeyBackward;
  }

}
